export default __webpack_public_path__ + "static/media/wht-cat-6.6e91c796.svg";